module.exports = __webpack_public_path__ + "static/img/1837_phase_function_Paper_Points.f3629dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1837_phase_function_Paper_Points.png
// module id = 4TIo
// module chunks = 0